export function collectVenueUserEmails(users = []) {
  const emails = users.map(user => user?.email?.trim()).filter(Boolean)

  return [...new Set(emails)]
}

export function formatEmailClipboardText(emails = []) {
  return collectVenueUserEmails(emails.map(email => ({ email }))).join('; ')
}

export async function copyTextToClipboard(text) {
  if (!text) {
    throw new Error('Nothing to copy')
  }

  if (navigator?.clipboard?.writeText) {
    await navigator.clipboard.writeText(text)
    return
  }

  const textarea = document.createElement('textarea')
  textarea.value = text
  textarea.setAttribute('readonly', '')
  textarea.style.position = 'absolute'
  textarea.style.left = '-9999px'
  document.body.appendChild(textarea)
  textarea.select()
  document.execCommand('copy')
  document.body.removeChild(textarea)
}

export async function copyVenueUserEmails(users = []) {
  const emails = collectVenueUserEmails(users)
  const text = emails.join('; ')

  if (!text) {
    throw new Error('No user emails to copy')
  }

  await copyTextToClipboard(text)
  return emails
}
